import type { CSSProperties, ReactNode } from 'react'

import cx from 'classnames'

import styles from './wrapper.module.css'

interface WrapperProps {
  children: ReactNode
  paddings?: boolean
  style?: CSSProperties
}

export function Wrapper ({ children, paddings, style }: WrapperProps): JSX.Element {
  return (
    <div
      className={cx(
        styles.container, {
          [styles.paddings as string]: paddings
        }
      )}
      style={style}
    >
      {children}
    </div>
  )
}
